import "./edit-employee-attachment.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormEmployeeAttachment from "../form-employee-attachment/form-employee-attachment";
import { useEditEmployeeAttachment } from "./edit-employee-attachment.hook";

export function EmployeeAttachment() {
  const {
    employeeAttachmentData,
    isLoading,
    employeeAttachmentError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditEmployeeAttachment();

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
        <FormEmployeeAttachment />
      </section>
    </div>
  );

  return (
    <div id="EmployeeAttachment" className="employee-attachment">
      <HeaderContent
        title={"Edit Employee Attachment"}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {employeeAttachmentError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EmployeeAttachment;
